import CardDeclined from 'card/CardDeclined';
import CardSuccess from 'card/CardSuccess';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useEffect } from 'react';
import api from 'api';
import Requesting from 'Requesting';
import { useNavigate } from 'react-router-dom';
import {
  pixelNative,
  pixelTikTok,
  googleAnalyticsSend,
  googleAdsSend,
} from './functions';

const ModalCard = ({
  offer,
  uuidOffer,
  paymentStatus,
  setPaymentStatus,
  getValues,
  selectedPlan,
  selectedBumps,
  fullName,
  pixels,
  recaptchaToken,
  googlePixels,
  googleAds,
  coupon,
}) => {
  const [error, setError] = useState(null);
  const [requesting, setRequesting] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let orderBumps = [];

    selectedBumps.forEach((item) => {
      if (item.quantity) {
        orderBumps.push(item.uuid);
      }
    });

    let card = {
      card_number: getValues('number').replaceAll(' ', ''),
      card_holder: getValues('cardHolder'),
      expiration_date: getValues('expiry'),
      cvv: getValues('cvc'),
      installments: getValues('installments'),
    };

    let body = {};

    let endpoint = '';
    if (offer.payment.type === 'single') {
      endpoint = '/sales/card';
      body = {
        card: card,
        offer_id: uuidOffer,
        order_bumps: orderBumps,
        coupon: coupon?.coupon,
      };
    } else {
      endpoint = '/sales/subscriptions';
      body = {
        card: card,
        offer_id: uuidOffer,
        plan_id: selectedPlan.uuid,
        payment_method: 'card',
        order_bumps: orderBumps,
      };
    }
    const headers = recaptchaToken
      ? {
          headers: {
            'g-recaptcha-response': recaptchaToken,
          },
        }
      : {};

    api
      .post(endpoint, body, headers)
      .then(async (r) => {
        if (r.data.status.id === 2) {
          setError(null);
          setPaymentStatus(true);
          const { upsell_url, sale_id } = r.data;
          pixels.forEach(() => {
            pixelNative('Purchase', {
              value: offer.price,
              currency: 'BRL',
              content_type: 'product',
              content_ids: [offer.uuid],
              num_items: 1,
            });

            pixelTikTok('CompletePayment', {
              value: offer.price,
              currency: 'BRL',
              content_type: 'product',
              content_id: offer.uuid,
              quantity: 1,
            });
          });

          if (googlePixels.length > 0) {
            googlePixels.forEach(() => {
              googleAnalyticsSend('purchase', {
                currency: 'BRL',
                value: offer.price,
                transaction_id: r.data.sale_id,
                items: [{ item_name: offer.product.name }],
              });
            });
          }

          if (googleAds.length > 0) {
            googleAds.forEach((item) => {
              if (item.settings.purchase)
                googleAdsSend({
                  currency: 'BRL',
                  value: offer.price,
                  transaction_id: r.data.sale_id,
                  send_to: `${item.settings.pixel_id}/${item.settings.purchase_label}`,
                });
            });
          }

          setTimeout(() => {
            if (upsell_url) {
              window.location = upsell_url;
            } else {
              navigate(`/compra-realizada/${sale_id}`);
            }
          }, 5000);
        } else {
          setError(`Error ao processar transação: ${r.data.status.name}`);
          setPaymentStatus(false);
        }
      })
      .catch((e) => {
        let showMessage = `${e.response.data.message}`;
        if (e.response.data.body) {
          if (e.response.data.body.errors.length > 0) {
            let firstError = e.response.data.body.errors[0];

            showMessage += `: ${firstError[Object.keys(firstError)[0]]}`;
          }
        }
        setError(showMessage);
        setPaymentStatus(false);
      })
      .finally(() => {
        setRequesting(false);
      });
  }, []);

  return (
    <>
      <Modal.Header closeButton={!requesting}>
        <b>Pagamento com Cartão de Crédito</b>
      </Modal.Header>
      <Modal.Body>
        <div className='modal-card'>
          {requesting && <Requesting />}
          {!requesting && paymentStatus === true && (
            <CardSuccess getValues={getValues} fullName={fullName} />
          )}
          {!requesting && paymentStatus === false && (
            <CardDeclined reason={error} />
          )}
        </div>
      </Modal.Body>
    </>
  );
};

export default ModalCard;
